import React from 'react';
import PropTypes from 'prop-types';
import { TreeNodeItem } from './TreeNode.styles';

const TreeNodeComponent = ({ label, onClickFunction, isOpen }) => {
  const glyphiconClassNames = ['triangle-icon', 'glyphicon'];
  glyphiconClassNames.push(isOpen ? 'glyphicon-triangle-bottom' : 'glyphicon-triangle-right');

  return (
    <TreeNodeItem onClick={onClickFunction}>
      <span className={glyphiconClassNames.join(' ')} />
      <span>{label}</span>
    </TreeNodeItem>
  );
};

TreeNodeComponent.propTypes = {
  label: PropTypes.string.isRequired,
  onClickFunction: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default TreeNodeComponent;
